import { cloneDeep } from "es-toolkit";

export class ObjectUtils {
  static purgePropRecursively(
    originalObject: Record<string, any>,
    prop: string
  ): Record<string, any> {
    return this._purgePropRecursively(cloneDeep(originalObject), prop)
  }

  private static _purgePropRecursively(
    obj: Record<string, any>,
    prop: string
  ): Record<string, any> {
    if (obj instanceof Array) {
      return obj.map((item) => this._purgePropRecursively(item, prop))
    } else if (obj instanceof Object) {
      delete obj[prop]
      Object.keys(obj).forEach((key) => {
        obj[key] = this._purgePropRecursively(obj[key], prop)
      })
    }
    return obj
  }
  
  static objectPathFixer(path: string): string {
    return path.replace(/\.(\d+)(?=\.|$)/g, '[$1]');
  }
}
